import { render, staticRenderFns } from "./node-area.vue?vue&type=template&id=aaace2e0&scoped=true"
import script from "./node-area.vue?vue&type=script&lang=js"
export * from "./node-area.vue?vue&type=script&lang=js"
import style0 from "./node-area.vue?vue&type=style&index=0&id=aaace2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaace2e0",
  null
  
)

export default component.exports